import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const MEL_TZ = "Australia/Melbourne";

// "7 Oct 2026" — matches the invoice PDF (%-d %b %Y), always rendered in
// Australia/Melbourne so a datetime stored in UTC never shows the wrong day.
// Date-only strings ("2026-10-14") are a positive-offset-safe calendar date.
export function fmtMelDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-AU", { timeZone: MEL_TZ, day: "numeric", month: "short", year: "numeric" });
}

// "7 Oct" — compact Melbourne date for secondary lines (e.g. "Due 14 Oct").
export function fmtMelDateShort(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-AU", { timeZone: MEL_TZ, day: "numeric", month: "short" });
}

// "7 Oct 2026, 8:00pm" — Melbourne datetime for session rows.
export function fmtMelDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d
    .toLocaleString("en-AU", {
      timeZone: MEL_TZ,
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    })
    .replace(/\s?([ap])m/i, (m, p) => p.toLowerCase() + "m");
}
